import routes from "../../utils/constants/apiRoutes";
import { createSlice, Dispatch } from '@reduxjs/toolkit'
import axios from "../../utils/axios";
import { searchParams } from "src/@types/data";
import { StringArraySupportOption } from "prettier";

export function fetchAllOrganization(filters?: any, signal?: AbortSignal, orgCode?: string) {
    return async function fetchAllOrganization(dispatch: Dispatch, getState: any) {
        try {
            const searchParams: searchParams = filters

            const queryString = "?" + new URLSearchParams(searchParams as URLSearchParams).toString();
            const response = await axios.get(orgCode ? `${orgCode}${routes.ORGANIZATION}${queryString}` : `${routes.ORGANIZATION}${queryString}`, { signal });
            return response;
        } catch (e) {
            console.log("error while fetchAllOrganization", e);
            throw e;
        }
    };
}

export function fetchOrganizationMetadata(orgCode?: string) {
    return async function fetchOrganizationMetadata(dispatch: Dispatch) {
        try {
            const response = await axios.get(orgCode ? `${orgCode}/organizations/metadata` : `/organizations/metadata`);
            return response.data;
        } catch (e) {
            console.error("Error fetching organization metadata", e);
            throw e;
        }
    };
}

export function fetchOrganizationById(id: string, orgCode?: string) {
    return async function fetchOrganizationById() {
        try {

            const response = await axios.get(orgCode ? `${orgCode}${routes.ORGANIZATION}/${id}` : `${routes.ORGANIZATION}/${id}`);
            return response;
        } catch (e) {
            console.log("error while fetchOrganizationById", e);
            throw e;
        }
    };
}

export function fetchUsersByOrgId(id: string, orgCode?: string) {
    return async function fetchOrganizationById() {
        try {

            const response = await axios.get(orgCode ? `${orgCode}${routes.ORGANIZATION}/orgUsers/${id}` : `${routes.ORGANIZATION}/orgUsers/${id}`);
            return response;
        } catch (e) {
            console.log("error while fetchOrganizationById", e);
            throw e;
        }
    };
}

export function createOrganization(data: any, orgCode?: string) {
    return async function createOrganization() {
        try {
            const response = await axios.post(orgCode ? `${orgCode}${routes.ORGANIZATION}` : `${routes.ORGANIZATION}`, { ...data, isEnterPrise: true });
            return response?.data;
        } catch (e) {
            throw e;
        }
    };
}

export function checkOrgName(data: any, field: string, orgCode?: string) {
    return async function checkOrgName() {
        try {
            const response = await axios.post(orgCode ? `${orgCode}${routes.ORGANIZATION}/check` : `${routes.ORGANIZATION}/check`, { data, field });
            return response?.data;
        } catch (e) {
            throw e;
        }
    };
}

export function updateOrganization(organizationData: any, orgCode?: string) {
    return async function updateOrganization() {
        try {
            const response = await axios.put(orgCode ? `${orgCode}${routes.ORGANIZATION}/update` : `${routes.ORGANIZATION}/update`, organizationData);
            return response?.data;
        } catch (e) {
            console.log("error while updateOrganization", e);
            throw e;
        }
    };
}

export function updateSelfOrganization(organizationData: any, orgCode?: string) {
    return async function updateSelfOrganization() {
        try {
            const response = await axios.put(orgCode ? `${orgCode}${routes.ORGANIZATION}/user/update` : `${routes.ORGANIZATION}/user/update`, organizationData);
            return response?.data;
        } catch (e) {
            console.log("error while updateSelfOrganization", e);
            throw e;
        }
    };
}

export function markAllNotificationAsRead(id: string, orgCode?: string) {
    return async function updateNotificationById() {
        try {
            const response = await axios.post(orgCode ? `${routes.NOTIFICATION}/allRead/${id}` : `${routes.NOTIFICATION}/allRead/${id}`);
            return response?.data;
        } catch (e) {
            console.log("error while fetchBookData", e);
        }
    };
}

export function updateDataStorageStatus(isUserDataStored: boolean, orgCode?: string) {
    return async function updateDataStorageStatus() {
        try {
            const response = await axios.put(orgCode ? `${orgCode}${routes.ORGANIZATION}/datastore` : `${routes.ORGANIZATION}/datastore`, { isUserDataStored: isUserDataStored });
            console.log("response", response);
            return response?.data;
        } catch (e) {
            console.log("error while updateDataStoreStatus", e);
            throw e;
        }
    };
}

export function fetchOrgUserSubscriptions(filters?: any, signal?: AbortSignal, orgCode?: string) {
    return async function fetchOrgUserSubscriptions(dispatch: Dispatch, getState: any) {
        try {
            const searchParams: searchParams = filters

            const queryString = "?" + new URLSearchParams(searchParams as URLSearchParams).toString();
            const response = await axios.get(orgCode ? `${orgCode}${routes.ORGANIZATION}/orgUsersSubscription${queryString}` : `${routes.ORGANIZATION}/orgUsersSubscription${queryString}`, { signal });
            return response;
        } catch (e) {
            console.log("error while fetchAllOrganization", e);
            throw e;
        }
    };
}

export function updateEncryptionKey(encryptionKey: string, orgCode?: string) {
    return async function updateEncryptionKey() {
        try {
            const response = await axios.put(orgCode ? `${orgCode}${routes.ORGANIZATION}/encryptionKey` : `${routes.ORGANIZATION}/encryptionKey`, { encryptionKey });
            console.log("response", response);
            return response?.data;
        } catch (e) {
            console.log("error while updateEncryptionKey", e);
            throw e;
        }
    };
}


